import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { Dropdown } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import { GetPetDropdownOptions } from '../../helpers/petHelpers';
import { FullPetDetailsPropTypes } from '../../propTypes/petDetails';

export const PetFilter = ({
  isLabelHidden = false,
  petDetails,
  policyFilter,
  onPetFilterChange,
  filterName = 'globalPetFilter'
}) => {
  const fieldFormContext = useFormContext();

  const petOptions = [{ label: 'All pets', value: '' }, ...GetPetDropdownOptions({ petDetails })];

  const [filterValue, setFilterValue] = useState(policyFilter || petOptions[0].value);

  useEffect(() => {
    if (policyFilter !== filterValue) {
      setFilterValue(policyFilter);
      fieldFormContext.setValue(filterName, policyFilter);
    }
  }, [policyFilter, filterValue, fieldFormContext, filterName]);

  return (
    <fieldset className="petFilterBar">
      {!isLabelHidden && <h5 aria-hidden="true">Filter by</h5>}

      <Dropdown
        fieldFormContext={fieldFormContext}
        name={filterName}
        value={filterValue}
        options={petOptions}
        label="Filter claims by pet"
        hideLabel
        customChangeHandler={onPetFilterChange}
        includeEmptyOption={false}
      />
    </fieldset>
  );
};

PetFilter.propTypes = {
  isLabelHidden: PropTypes.bool,
  petDetails: PropTypes.arrayOf(FullPetDetailsPropTypes),
  policyFilter: PropTypes.string,
  onPetFilterChange: PropTypes.func,
  filterName: PropTypes.string
};
